module.exports = __webpack_public_path__ + "img/coinmarketcap.0998b8f3.png";